// Moved from `src/features/voice-assistant/feedback/client.ts` with its subject.
// Transport comes from the `@heidi/api` configured-client registry — the app's
// own `scribeHttpV2` singleton, same interceptors and same retry/refresh state,
// so the POST is byte-identical to the pre-move `@/utils/scribeHTTP` read.
//
// The `no-new-carved-domain-data` suppression the app path carried is gone with
// the app path: that rule scopes `src/**`, and the noun collision it was
// disclaiming (Talk-to-Heidi voice feedback on `/voice`, not session
// note/transcript feedback) is now stated by the file's location instead.
import { getScribeHttpClients } from '@heidi/api/client';

import type {
  SubmitVoiceFeedbackRequest,
  SubmitVoiceFeedbackResponse,
} from '../../contracts/voice-feedback.types';

const BASE = '/voice';

export const voiceFeedbackClient = {
  submitFeedback: (body: SubmitVoiceFeedbackRequest) =>
    getScribeHttpClients().scribeHttpV2.post<SubmitVoiceFeedbackResponse>(
      `${BASE}/feedback`,
      body
    ),
};
